module.exports = __webpack_public_path__ + "img/posterVideo.3939e5c9.jpg";